import * as React from "react";

const SvgIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="75"
    height="100"
    fill="none"
    viewBox="0 0 648 548"
  >
  <path d="M274 12C112 12 12 112 12 274C12 436 112 536 274 536C342 536 402 512 442 472C462 452 492 442 522 442C582 442 636 388 636 322C636 142 474 12 274 12Z" stroke="currentColor" strokeWidth="24" strokeLinecap="round" strokeLinejoin="round"/>
  <path d="M182 212C198.569 212 212 198.569 212 182C212 165.431 198.569 152 182 152C165.431 152 152 165.431 152 182C152 198.569 165.431 212 182 212Z" fill="currentColor"/>
  <path d="M312 172C328.569 172 342 158.569 342 142C342 125.431 328.569 112 312 112C295.431 112 282 125.431 282 142C282 158.569 295.431 172 312 172Z" fill="currentColor"/>
  <path d="M442 242C458.569 242 472 228.569 472 212C472 195.431 458.569 182 442 182C425.431 182 412 195.431 412 212C412 228.569 425.431 242 442 242Z" fill="currentColor"/>
  <path d="M212 387C236.853 387 257 366.853 257 342C257 317.147 236.853 297 212 297C187.147 297 167 317.147 167 342C167 366.853 187.147 387 212 387Z" stroke="currentColor" strokeWidth="24"/>
  </svg>
);

export default SvgIcon;
